import '../Availability/Availability.scss';

import { useSelector } from 'react-redux';

import GroomersDropdown from 'organisms/GroomersDropdown';
import { UserAvatarSmall } from 'organisms/GroomersDropdown/UserAvatar';

import PublishButton from '../Availability/Components/PublishButton';
import UnavailableDrawerContent from './components/UnavailableDrawerContent';

export default function UnavailableDrawer() {
  const { isOwner, firstName } = useSelector((state) => state.user);

  return (
    <div className="availability-drawer flex-column align-end">
      <div className="w-100">
        <div className="flex-row justify-between mb-25">
          <h2 className="f26">Unavailable</h2>
          <PublishButton />
        </div>
        {isOwner ? (
          <GroomersDropdown
            disableAllOption
            className="availability-drawer-groomers-dropdown"
            Element={UserAvatarSmall}
          />
        ) : (
          <div className="flex-row b-white border-light-purple mb-12 p-20 radius-24">
            <UserAvatarSmall />
            <p className="f14">{firstName}</p>
          </div>
        )}

        <UnavailableDrawerContent />
      </div>
    </div>
  );
}
